// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3e4199f8","232":"f1e5f1d4","237":"2fd2ee77","526":"2a2826b7"}[chunkId] + ".chunk.js";
};